import { ReactNode } from 'react'
import { useSystemFeatureFlagIsActive } from 'utils/systemUtils'
import { CustomTabPanel } from './components/CustomTabPanel'
import { NewNotificationOptimizationLogs } from './components/NewNotificationOptimizationLogs'
import { NotificationOptimizationLogs } from './components/NotificationOptimizationLogs'
import { useOptimizationLogVisibility } from './hooks/useOptimizationLogVisibility'
import { OPTIMIZATION_TAB_INDEX } from './NotificationCenter'
import styles from './NotificationCenter.module.less'

type NotificationOptimizationsTabProps = {
  selectedFilters: string[]
  date: ISODateTime
}

export default function NotificationOptimizationsTab({
  selectedFilters,
  date,
}: NotificationOptimizationsTabProps): ReactNode {
  const { showNewOptimizationLogs } = useOptimizationLogVisibility()

  // With a draft production plan in play, a `regular` job is the step that publishes a
  // finished draft rather than the optimization itself — both log implementations word
  // and draw it differently.
  const treatRegularAsPublished = useSystemFeatureFlagIsActive('use_draftproductionplan')

  return (
    <CustomTabPanel index={OPTIMIZATION_TAB_INDEX}>
      <div className={styles.NotificationCenter_Body}>
        {showNewOptimizationLogs ? (
          <NewNotificationOptimizationLogs
            selectedFilters={selectedFilters}
            date={date}
            treatRegularAsPublished={treatRegularAsPublished}
          />
        ) : (
          <NotificationOptimizationLogs
            selectedFilters={selectedFilters}
            date={date}
            treatRegularAsPublished={treatRegularAsPublished}
          />
        )}
      </div>
    </CustomTabPanel>
  )
}
